/**
 * @param sel1 Selector of first element
 * @param dir1 Direction of first element (0 = left, 1 = right)
 * @param minSpace Minimum allowed space between elements in px - default: 0
 * @param elem2hide Selector of element to hide if elements collide, default: element defined as right element
 * @param leftElem Element number to hide if elements collide (1 or 2), default: 1
 */
 export default class DynamicResponsiveGroup
 {
     constructor(sel1, sel2, minSpace = 1, elem2hide = null, leftElem = 1) {
         this.elem1 = document.querySelector(sel1);
         this.elem2 = document.querySelector(sel2);
         this.minSpace = minSpace;
         this.leftElem = parseInt(leftElem);
 
         if (null === elem2hide) {
             this.elem2hide = [ this.leftElem === 1 ? this.elem2 : this.elem1 ];
         } else {
             this.elem2hide = Array.from(document.querySelectorAll(elem2hide));
         }
 
         if ('undefined' === typeof this.elem1) {
             throw new Error('Element not found: ' + sel1)
         }
 
         if ('undefined' === typeof this.elem2) {
             throw new Error('Element not found: ' + sel2)
         }
 
         if ('undefined' === typeof this.elem2hide) {
             throw new Error('Element to hide not found')
         }
 
        this.elem2hide.forEach(elem => elem.style.visibility = 'visible');
     }
 
     getMinSpace() {
         return this.minSpace
     }
 
     getLeftElement() {
         if (this.leftElem === 1) {
             return this.elem1;
         }
 
         return this.elem2;
     }
 
     getRightElement() {
         if (this.leftElem === 2) {
             return this.elem1;
         }
 
         return this.elem2;
     }
 
     isHidden() {
         return this.elem2hide[0]?.style.visibility === 'hidden';
     }
 
     hide() {
         if ( ! this.isHidden()) {
             this.elem2hide.forEach(elem => {
                 elem.style.visibility = 'hidden';
                 elem.style.pointerEvents = 'none';
             })
         }
     }
 
     show() {
         if (this.isHidden()) {
             this.elem2hide.forEach(elem => {
                 elem.style.visibility = 'visible';
                 elem.style.pointerEvents = 'all';
             })
         }
     }
 }
 